var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 20C20.25 19.5858 20.5858 19.25 21 19.25H28C28.4142 19.25 28.75 19.5858 28.75 20C28.75 20.4142 28.4142 20.75 28 20.75H21C20.5858 20.75 20.25 20.4142 20.25 20Z",
    fill: "#5C697B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 22.25C20.5858 22.25 20.25 22.5858 20.25 23C20.25 23.4142 20.5858 23.75 21 23.75H26C26.4142 23.75 26.75 23.4142 26.75 23C26.75 22.5858 26.4142 22.25 26 22.25H21Z",
    fill: "#5C697B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 15.25C17.8766 15.25 15.75 17.3766 15.75 20V30C15.75 32.0711 17.4289 33.75 19.5 33.75H30.5C31.4665 33.75 32.25 32.9665 32.25 32V17C32.25 16.0335 31.4665 15.25 30.5 15.25H20.5ZM30.75 26.25V17C30.75 16.8619 30.6381 16.75 30.5 16.75H20.5C18.7051 16.75 17.25 18.2051 17.25 20V26.9997C17.8767 26.529 18.6558 26.25 19.5 26.25H30.75ZM30.75 27.75H19.5C18.2574 27.75 17.25 28.7574 17.25 30C17.25 31.2426 18.2574 32.25 19.5 32.25H30.5C30.6381 32.25 30.75 32.1381 30.75 32V27.75Z",
    fill: "#5C697B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContent);
export default __webpack_public_path__ + "static/media/content.712970137d500a082e27827edc5d4df8.svg";
export { ForwardRef as ReactComponent };